(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapBuckleData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "buckles": [
    {
      "id": "none",
      "title": "Own Buckle",
      "type": "own",
      "finish": null,
      "finishLabel": "Own Buckle",
      "helperText": "Use your own buckle; reference images are required.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "none"
      },
      "disabled": false,
      "priceModifier": 0
    },
    {
      "id": "classic-silver",
      "title": "Silver Classic Buckle",
      "type": "classic",
      "finish": "silver",
      "finishLabel": "Silver",
      "helperText": "Supply the strap with Silver Classic Buckle.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-silver"
      },
      "disabled": false,
      "priceModifier": 0
    },
    {
      "id": "classic-yellow-gold",
      "title": "Yellow Gold Classic Buckle",
      "type": "classic",
      "finish": "yellow-gold",
      "finishLabel": "Yellow Gold",
      "helperText": "Supply the strap with Yellow Gold Classic Buckle.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-yellow-gold"
      },
      "disabled": false,
      "priceModifier": 0
    },
    {
      "id": "classic-rose-gold",
      "title": "Rose Gold Classic Buckle",
      "type": "classic",
      "finish": "rose-gold",
      "finishLabel": "Rose Gold",
      "helperText": "Supply the strap with Rose Gold Classic Buckle.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-rose-gold"
      },
      "disabled": false,
      "priceModifier": 0
    },
    {
      "id": "classic-black",
      "title": "Black Classic Buckle",
      "type": "classic",
      "finish": "black",
      "finishLabel": "Black",
      "helperText": "Supply the strap with Black Classic Buckle.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-black"
      },
      "disabled": false,
      "priceModifier": 0
    },
    {
      "id": "butterfly-silver",
      "title": "Silver Butterfly Clasp",
      "type": "butterfly",
      "finish": "silver",
      "finishLabel": "Silver",
      "helperText": "Supply the strap with Silver Butterfly Clasp.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "butterfly-silver"
      },
      "disabled": false,
      "priceModifier": 10
    },
    {
      "id": "butterfly-yellow-gold",
      "title": "Yellow Gold Butterfly Clasp",
      "type": "butterfly",
      "finish": "yellow-gold",
      "finishLabel": "Yellow Gold",
      "helperText": "Supply the strap with Yellow Gold Butterfly Clasp.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "butterfly-yellow-gold"
      },
      "disabled": false,
      "priceModifier": 10
    },
    {
      "id": "butterfly-black",
      "title": "Black Butterfly Clasp",
      "type": "butterfly",
      "finish": "black",
      "finishLabel": "Black",
      "helperText": "Supply the strap with Black Butterfly Clasp.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "butterfly-black"
      },
      "disabled": false,
      "priceModifier": 10
    }
  ],
  "catalogueHiddenWhen": {
    "buckleWidth": "other"
  },
  "upload": {
    "requiredWhen": {
      "any": [
        {
          "eq": [
            "buckle",
            "none"
          ]
        },
        {
          "eq": [
            "buckleWidth",
            "other"
          ]
        }
      ]
    },
    "acceptedExtensions": [
      "jpg",
      "jpeg",
      "png",
      "pdf"
    ],
    "maxFiles": 2,
    "maxMegabytesPerFile": 8
  }
});

  function getOptions() {
    return DATA.buckles;
  }

  function getOption(optionId) {
    return DATA.buckles.find((item) => item.id === optionId && !item.disabled) || null;
  }

  function isCatalogueActive(rawState) {
    return rawState.buckleWidth !== DATA.catalogueHiddenWhen.buckleWidth;
  }

  function isUploadActive(rawState) {
    return rawState.buckleWidth === 'other' || rawState.buckle === 'none';
  }

  function fileExtension(file) {
    const name = typeof file?.name === 'string' ? file.name.trim().toLowerCase() : '';
    const dotIndex = name.lastIndexOf('.');
    return dotIndex > -1 ? name.slice(dotIndex + 1) : '';
  }

  function validateFiles(files, options) {
    const list = Array.from(files || []);
    const required = options?.required !== false;
    if (!list.length) return required ? 'Upload at least one buckle image or PDF.' : '';
    if (list.length > DATA.upload.maxFiles) return `Upload no more than ${DATA.upload.maxFiles} files.`;
    const invalidType = list.find((file) => !DATA.upload.acceptedExtensions.includes(fileExtension(file)));
    if (invalidType) return `${invalidType.name || 'A selected file'} must be JPG, JPEG, PNG or PDF.`;
    const maxBytes = DATA.upload.maxMegabytesPerFile * 1024 * 1024;
    const oversized = list.find((file) => !Number.isFinite(file?.size) || file.size > maxBytes);
    if (oversized) return `${oversized.name || 'A selected file'} must be ${DATA.upload.maxMegabytesPerFile} MB or smaller.`;
    return '';
  }

  return Object.freeze({ DATA, getOptions, getOption, isCatalogueActive, isUploadActive, validateFiles });
});
